const RedeemGiftCard = {
    baseStyle: {
        redeemGcText: {
            fontWeight: '400',
            lineHeight: '26px',
            fontSize: {base: '16px', lg: '18px'},
            letterSpacing: '0.09px',
            color: 'black.100',
            fontFamily: 'body'
        },
        linkStyles: {
            textDecoration: 'underline',
            textTransform: 'capitalize',
            width: 'fit-content',
            maxWidth: '40%',
            color: 'black.100',
            fontWeight: '400',
            fontSize: '16px',
            letterSpacing: '0.08px',
            textUnderlineOffset: '4px',
            transition: 'color, 0.3s ease',
            _hover: {
                color: 'teal.600'
            }
        },
        accordionButton: {
            display: 'flex',
            alignItems: 'center',
            gap: '15px',
            width: 'fit-content',
            cursor: 'pointer',
            _hover: {bg: 'none'},
            marginBottom: '0px',
            p: 0
        },
        logoImage: {
            width: '32px',
            height: '32px',
            marginLeft: '5px'
        },
        appliedCardRow: {
            display: 'inline-flex',
            justifyContent: {base: 'space-between', md: 'unset'},
            alignItems: {base: 'center', md: 'unset'},
            gap: '20px'
        },
        appliedCardRowFull: {
            display: 'inline-flex',
            justifyContent: {base: 'space-between', md: 'unset'},
            alignItems: {base: 'start', md: 'unset'},
            gap: '20px',
            flexDirection: {base: 'column', md: 'row'}
        },
        appliedCardText: {
            fontSize: '16px',
            fontWeight: '300',
            lineHeight: '25px',
            maxWidth: '60%',
            letterSpacing: '0.08px',
            color: 'black.100'
        },
        appliedCardTextFull: {
            fontSize: '16px',
            fontWeight: '300',
            lineHeight: '25px',
            maxWidth: {base: '100%', md: '60%'},
            letterSpacing: '0.08px',
            color: 'black.100'
        },
        appliedCardsPanel: {
            padding: '0px',
            display: 'grid',
            gap: {base: '15px', lg: '0px'},
            margin: '0px'
        },
        formPanel: {
            padding: '0px',
            marginTop: '20px'
        },
        formInnerWrapper: {
            display: {base: 'inline-flex', md: 'grid'},
            width: '100%'
        },
        fieldsGrid: {
            templateColumns: {base: '1fr', md: '1fr 1fr 0fr'},
            gap: {base: '10px', lg: '15px'},
            width: {base: '90%', md: 'unset'}
        },
        mobileCrossButton: {
            alignContent: 'center',
            display: {base: 'block', md: 'none'},
            width: {base: '10%', md: 'unset'}
        },
        desktopCrossButton: {
            alignContent: 'center',
            display: {base: 'none', md: 'block'}
        },
        closeButton: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '15px',
            height: '15px',
            margin: {base: 'auto', md: 'unset'},
            position: 'relative'
        },
        formActionsRow: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
            mt: '20px'
        },
        submitButton: {
            fontSize: '14px',
            fontWeight: '400',
            lineHeight: '22px',
            letterSpacing: '0.07px',
            color: 'gray.200',
            padding: '4px 25px'
        }
    }
}

export default RedeemGiftCard
